import { Component, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnDestroy {
  @Input() isLoading = false;
  @Input() message: string;
  selectedProduct: string = null;
  productList: any[];
  productData: any;
  productOriginalData: any;

  ngOnDestroy(): void {
    this.productData.unsubscribe();
    this.productOriginalData.unsubscribe();
  }
}
